import { Document, Image, Page, StyleSheet } from "@react-pdf/renderer";

// 100mm / 60mm
const BrandingLabel = ({ data: { branding_label_url, quantity } }) => (
  <Document>
    {Array.from({ length: quantity })
      .fill(null)
      .map((_, index) => (
        <Page
          key={index}
          size={{
            width: 283.465, // 100 mm
            height: 170.079, // 60 mm
          }}
          style={styles.page}
        >
          <Image style={styles.image} src={branding_label_url} />
        </Page>
      ))}
  </Document>
);

export default BrandingLabel;

const styles = StyleSheet.create({
  page: {
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
    padding: 5,
  },
  image: {
    width: "100%",
    height: "auto",
  },
});
